import { Popper, Paper, Typography, Box } from "@mui/material";

/**
 * A hint that appears near the filter dropdowns to guide users
 * to complete their selection (Kategorie, Parameter, Zeitabschnitt).
 */
const FilterSelectionHint = ({ anchorEl, open, message }) => {
  const ARROW_SIZE = 14; // Size of the arrow in pixels
  return (
    <Popper
      open={open && Boolean(anchorEl)}
      anchorEl={anchorEl}
      placement="right-end"
      sx={{ zIndex: 2000, marginLeft: "-6px !important" }}
    >
      <Paper
        elevation={1}
        sx={(theme) => ({
          border: `1px solid ${theme.palette.brand?.red}`,
          backgroundColor: "#f7f7f7",
          position: "relative",
          padding: "4px",
          maxWidth: 420,
        })}
      >
        <Box
          sx={(theme) => ({
            position: "absolute",
            left: -ARROW_SIZE,
            top: `calc(50% - ${ARROW_SIZE}px)`,
            width: 0,
            height: 0,
            borderTop: `${ARROW_SIZE}px solid transparent`,
            borderBottom: `${ARROW_SIZE}px solid transparent`,
            borderRight: `${ARROW_SIZE}px solid ${theme.palette.brand?.red}`,
          })}
        />

        <Typography data-cy="filter-hint" style={{ fontSize: "small", paddingLeft: 3 }}>
          {message}
        </Typography>
      </Paper>
    </Popper>
  );
};

export default FilterSelectionHint;
